import { createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card-body" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-6" }
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = /*#__PURE__*/_createVNode("label", null, "제목", -1)
const _hoisted_6 = { class: "form-group grid" }
const _hoisted_7 = /*#__PURE__*/_createVNode("label", null, "내용", -1)
const _hoisted_8 = { class: "col-md-6" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = {
  role: "group",
  class: "form-group"
}
const _hoisted_11 = /*#__PURE__*/_createVNode("label", {
  class: "col-form-label col-sm-3",
  style: {"padding-left":"0px"}
}, " App ", -1)
const _hoisted_12 = {
  class: "col-sm-12",
  style: {"padding-left":"0px"}
}
const _hoisted_13 = /*#__PURE__*/_createVNode("option", {
  value: "0",
  selected: ""
}, "Uhshin", -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("option", { value: "1" }, "Partner", -1)
const _hoisted_15 = {
  role: "group",
  class: "form-group"
}
const _hoisted_16 = /*#__PURE__*/_createVNode("label", {
  class: "col-form-label col-sm-3",
  style: {"padding-left":"0px"}
}, " OS ", -1)
const _hoisted_17 = {
  class: "col-sm-12",
  style: {"padding-left":"0px"}
}
const _hoisted_18 = /*#__PURE__*/_createVNode("option", {
  value: "0",
  selected: ""
}, "전체", -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("option", { value: "1" }, "iOS", -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("option", { value: "2" }, "Android", -1)
const _hoisted_21 = { class: "form-group" }
const _hoisted_22 = { class: "col-sm-9" }
const _hoisted_23 = /*#__PURE__*/_createVNode("label", null, "노출 여부", -1)
const _hoisted_24 = { class: "form-group" }
const _hoisted_25 = { class: "c-switch c-switch-pill c-switch-primary" }
const _hoisted_26 = /*#__PURE__*/_createVNode("span", { class: "c-switch-slider" }, null, -1)
const _hoisted_27 = { class: "form-group" }
const _hoisted_28 = { class: "col-sm-9" }
const _hoisted_29 = /*#__PURE__*/_createVNode("label", null, "상단 고정 여부", -1)
const _hoisted_30 = { class: "form-group" }
const _hoisted_31 = { class: "c-switch c-switch-pill c-switch-primary" }
const _hoisted_32 = /*#__PURE__*/_createVNode("span", { class: "c-switch-slider" }, null, -1)
const _hoisted_33 = { class: "form-group" }
const _hoisted_34 = { class: "col-sm-9" }
const _hoisted_35 = /*#__PURE__*/_createVNode("label", null, "화면 좌우여백 없애기", -1)
const _hoisted_36 = { class: "form-group" }
const _hoisted_37 = { class: "c-switch c-switch-pill c-switch-primary" }
const _hoisted_38 = /*#__PURE__*/_createVNode("span", { class: "c-switch-slider" }, null, -1)
const _hoisted_39 = /*#__PURE__*/_createVNode("button", {
  type: "submit",
  class: "btn btn-primary"
}, "Add new", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_editor = _resolveComponent("editor")
  const _component_file_upload = _resolveComponent("file-upload")

  return (_openBlock(), _createBlock("div", {
    class: ["card", { loading: _ctx.loading }]
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("form", {
        onSubmit: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
      }, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _hoisted_5,
              _withDirectives(_createVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.notification.title = $event)),
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.notification.title]
              ])
            ]),
            _createVNode("div", _hoisted_6, [
              _hoisted_7,
              _createVNode(_component_editor, {
                ref: "customEditor",
                "set-contents": _ctx.notification.description
              }, null, 8, ["set-contents"])
            ])
          ]),
          _createVNode("div", _hoisted_8, [
            _createVNode("div", _hoisted_9, [
              _createVNode(_component_file_upload, {
                ref: "thumbnailFile",
                title: "Thumbnail",
                "folder-name": 'notification'
              }, null, 512)
            ]),
            _createVNode("div", _hoisted_10, [
              _hoisted_11,
              _createVNode("div", _hoisted_12, [
                _withDirectives(_createVNode("select", {
                  class: "form-control",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.notification.app = $event)),
                  required: ""
                }, [
                  _hoisted_13,
                  _hoisted_14
                ], 512), [
                  [_vModelSelect, _ctx.notification.app]
                ])
              ])
            ]),
            _createVNode("div", _hoisted_15, [
              _hoisted_16,
              _createVNode("div", _hoisted_17, [
                _withDirectives(_createVNode("select", {
                  class: "form-control",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.notification.os = $event)),
                  required: ""
                }, [
                  _hoisted_18,
                  _hoisted_19,
                  _hoisted_20
                ], 512), [
                  [_vModelSelect, _ctx.notification.os]
                ])
              ])
            ]),
            _createVNode("div", _hoisted_21, [
              _createVNode("div", _hoisted_22, [
                _hoisted_23,
                _createVNode("div", _hoisted_24, [
                  _createVNode("label", _hoisted_25, [
                    _withDirectives(_createVNode("input", {
                      type: "checkbox",
                      class: "c-switch-input",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.notification.show = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.notification.show]
                    ]),
                    _hoisted_26
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_27, [
              _createVNode("div", _hoisted_28, [
                _hoisted_29,
                _createVNode("div", _hoisted_30, [
                  _createVNode("label", _hoisted_31, [
                    _withDirectives(_createVNode("input", {
                      type: "checkbox",
                      class: "c-switch-input",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.notification.pin = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.notification.pin]
                    ]),
                    _hoisted_32
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_33, [
              _createVNode("div", _hoisted_34, [
                _hoisted_35,
                _createVNode("div", _hoisted_36, [
                  _createVNode("label", _hoisted_37, [
                    _withDirectives(_createVNode("input", {
                      type: "checkbox",
                      class: "c-switch-input",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.notification.no_margin_layout = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.notification.no_margin_layout]
                    ]),
                    _hoisted_38
                  ])
                ])
              ])
            ])
          ])
        ]),
        _hoisted_39
      ], 32)
    ])
  ], 2))
}